import PrivacyPolicy from "../en/privacy-policy";
export default PrivacyPolicy;
